import api from '@/units/server/api.js';
import config from '@/units/server/config.js';
import Common from '@/units/Common.js';

export default {
	// 获取个人信息
	getUserInfo(success) {
		api.getUserInfo().then((data) => {
			uni.setStorageSync('user', data.user);
			success(data.user);
		});
	},
	// 上传图片
	upChooseImage(callBack, count = 1) {
		uni.chooseImage({
			count,
			success(res) {
				if (res.tempFilePaths.length > 0) {
					let filePath = res.tempFilePaths[0];
					//进行上传操作
					api.uploadPic(filePath, 'task').then((data) => {
						callBack && callBack(JSON.parse(data).data);
					});
				}
			},
		});
	},
	// 支付
	requestPayment(type, orderInfo, callBack, error) {
		uni.requestPayment({
			provider: type,
			orderInfo: orderInfo, //微信、支付宝订单数据
			success: (res) => {
				console.log('success:' + JSON.stringify(res));
				callBack && callBack(res);
			},
			fail: (err) => {
				console.log('fail:' + JSON.stringify(err));
				error && error(err);
			},
		});
	},

	// 图片增加路径
	returnImgUrl(path) {
		return config.imgHost + path;
	},

	// 页面跳转
	commonJump(path, clear = false) {
		if (!path) {
			console.warn('请检查跳转地址，跳转地址为空');
			return;
		}
		if (clear) {
			uni.reLaunch({
				url: path,
			});
		} else {
			uni.navigateTo({
				url: path,
			});
		}
	},

	// 页面弹出框
	commonToast(title, type = 'none', callback) {
		var toastDuration = 1000;
		var toastParams = {
			title: title,
			duration: toastDuration,
			icon: type,
		};
		uni.showToast(toastParams);
		if (callback) {
			setTimeout(() => {
				callback();
			}, toastDuration);
		}
	},

	// 页面弹出模态框
	commonMoadl(params) {
		uni.showModal({
			title: params.title, // 提示标题
			content: params.content, // 提示内容
			showCancel: params.showCancel, // 是否显示取消按钮
			cancelText: params.cancelText, // 取消文字按钮
			confirmText: params.confirmText, // 确认按钮文字
			confirmColor: params.confirmColor, // 确认文字颜色
			success: (res) => {
				if (res.confirm) {
					params.success && params.success();
				} else if (res.cancel) {
					params.cancel && params.cancel();
				}
			},
		});
	},

	// app更新
	appUpData(callBack) {
		// #ifdef APP-PLUS
		plus.runtime.getProperty(plus.runtime.appid, (wgtinfo) => {
			api.fetchVersionNumber('', {
				success: (data) => {
					if (data.version_number * 1 > wgtinfo.version * 1) {
						return;
						// 需要升级
						this.commonMoadl({
							title: '检测更新',
							content: '已有最新版，请尽快升级',
							showCancel: false,
							confirmText: '去下载',
							success: () => {
								plus.runtime.openURL(config.imgHost + '/pages/download/download');
							},
							cancel: () => {
								uni.removeStorageSync('token');
								uni.removeStorageSync('user');
								plus.runtime.openURL(config.imgHost + '/pages/loginIn/loginIn');
							},
						});
					} else {
						callBack && callBack();
					}
				},
			});
		});
		// #endif

		// #ifdef H5
		callBack && callBack();
		// #endif
	},

	// 复制
	copyText(obj, callback) {
		uni.setClipboardData({
			data: obj.value,
			success: () => {
				uni.showToast({
					icon: 'none',
					title: obj.alertText ? obj.alertText : '复制成功',
					mask: true,
					duration: 800,
					success: (res) => {
						callback && callback(res);
					},
				});
			},
		});
	},

	// 获取用户定位
	getUserLocation(obj) {
		uni.getLocation({
			type: 'gcj02',
			geocode: true,
			isHighAccuracy: true,
			success: (res) => {
				obj.success && obj.success(res);
			},
			fail: (err) => {
				obj.fail && obj.fail(err);
			},
		});
	},

	// 表单验证方法
	// 该方法验证失误会返回一个fasle
	// 成功之后则会返回一个 key: value的形式 会去除其他的验证
	// 如有不需要验证的属性，则该属性不写成key: {}, 而是key:value
	formValidation(reg) {
		let copy = JSON.parse(JSON.stringify(reg));
		for (var key in copy) {
			if (Object.prototype.toString.call(copy[key]) == '[object Object]' && !copy[key].value) {
				// 如果遇到未通过验证的值则返回false
				Common.commonToast(copy[key].error);
				return false;
			}
		}
		// 通过全部验证后 去除验证仅保留值
		for (var key in copy) {
			if (Object.prototype.toString.call(copy[key]) == '[object Object]') {
				copy[key] = copy[key].value;
			}
		}
		return copy;
	},
	// 返回上一页
	// 由于h5刷新过页面后会出现页面栈丢失的情况所以需要依靠条件编译去判断
	navigateBack(isHome) {
		// #ifdef H5
		isHome
			? uni.reLaunch({
					url: '/pages/index/index',
			  })
			: window.history.back();
		// #endif
		// #ifndef H5
		uni.navigateBack();
		// #endif
	},
	// 验证手机号
	validationMobile(mobile) {
		return /^[1][3,4,5,6.7,8,9][0-9]{9}$/.test(mobile);
	},

	// 富文本html片段处理
	richTextHtmlHandle(html) {
		let nweHtml = html;
		// 处理图片
		nweHtml = nweHtml.replace(/<img([\s\w"-=\/\.:;]+)/gi, '<img style="width: 100%;" $1');
		// 处理p
		// nweHtml = nweHtml.replace(/<p()/ig, '<p style="padding: 0 15px;" $1');
		// 返回新片段
		return nweHtml;
	},

	pageShareInit(options) {
		const pages = getCurrentPages();
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf('micromessenger') != -1) {
			api.weChatShareConfig({
				url: window.location.href,
				// url: window.location.origin + window.location.pathname,
			}).then((wxData) => {
				jWeixin.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: wxData.appId, // 必填，公众号的唯一标识
					timestamp: wxData.timestamp, // 必填，生成签名的时间戳
					nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
					signature: wxData.signature, // 必填，签名
					jsApiList: wxData.jsApiList, // 必填，需要使用的JS接口列表
				});
			});

			jWeixin.ready(function () {
				// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
				// 分享给朋友
				jWeixin.updateAppMessageShareData({
					title: options.title, // 分享标题
					desc: options.desc, // 分享描述
					link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: options.imgUrl, // 分享图标
					success: function () {
						// 设置成功
					},
				});
				// 分享到朋友圈
				jWeixin.updateTimelineShareData({
					title: options.title, // 分享标题
					link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: options.imgUrl, // 分享图标
					success: function () {
						// 设置成功
					},
				});
			});
		}
	},
};
